export default "__VITE_ASSET__BFDczdYA__"